import { render, staticRenderFns } from "./blind-box-button.vue?vue&type=template&id=247b1102&scoped=true&"
import script from "./blind-box-button.vue?vue&type=script&lang=js&"
export * from "./blind-box-button.vue?vue&type=script&lang=js&"
import style0 from "./blind-box-button.vue?vue&type=style&index=0&id=247b1102&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247b1102",
  null
  
)

export default component.exports